var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"header"},[_c('Navigation')],1),_c('div',{staticClass:"content mb-5"},[_c('b-container',{staticClass:"pt-4"},[_c('div',{staticClass:"content__container"},[_c('router-view')],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }